import { saveAs } from 'file-saver';

export default class ExcelDownload {
    // payload = {
    //     name: 'carros'   
    //     header: ['cor', 'ano', 'marca', 'modelo'],
    //     body: [
    //         ['azul', '2017', 'honda', 'civic'],
    //         ['laranja', '2005', 'ford', 'fiesta'],
    //         ['preto', '2022', 'fiat', 'fastback'],
    //     ]
    // }
    // excel:
    // cor    | ano   | marca   | modelo 
    // azul   | 2017  | honda   | civic 
    // laranja| 2005  | ford    | fiesta 
    // preto  | 2022  | fiat    | fastback

    constructor(payload) {
        const XLSX = require('sheetjs-style');
        var wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "SheetJS",
            Subject: "Valores",
            Author: "Club da Cotação",
            CreatedDate: new Date()
        };
        wb.SheetNames.push(payload.tableName.trim());
        const now = new Date()
        var ws_data = [['Club da Cotação', payload.userName, now.toLocaleDateString(), payload.cot],payload.header, ...payload.body]; 
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [ { wch: 15 }, { wch: 25 }, { wch: 25 }, { wch: 15 },{ wch: 40 },{ wch: 35 },{ wch: 20 },{ wch: 10 },{ wch: 20 },{ wch: 20 },{ wch: 20 },{ wch: 20 },{ wch: 20 }, ]
        const header = {
            font: {
                bold: true,
                color: { rgb: "FFFFFF" }
            },
            fill:{
                fgColor: { rgb: "FF7110" }
            }
        }
        const title = {
            font: {
                bold: true,
            }
        }
        ws["A1"].s = title
        ws["B1"].s = title
        ws["C1"].s = title

        ws["A2"].s = header
        if(ws["B2"]) ws["B2"].s = header
        if(ws["C2"]) ws["C2"].s = header
        if(ws["D2"]) ws["D2"].s = header
        if(ws["E2"]) ws["E2"].s = header
        if(ws["F2"]) ws["F2"].s = header
        if(ws["G2"]) ws["G2"].s = header
        if(ws["H2"]) ws["H2"].s = header
        if(ws["I2"]) ws["I2"].s = header
        if(ws["J2"]) ws["J2"].s = header
        if(ws["K2"]) ws["K2"].s = header
        if(ws["L2"]) ws["L2"].s = header
        if(ws["M2"]) ws["M2"].s = header
        wb.Sheets[payload.tableName.trim()] = ws;
        var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
        saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), payload.tableName.trim() + '.xlsx');
    }
}